<div class="container">

  <mat-card *ngIf="!isQuoteGeneration">

    <h2 mat-title>Cancelación de Cheques</h2>
    <account-search resource="loans" (accountDetailEvent)="updateAccountDetail($event)"></account-search>

  </mat-card>

  <div id="search-divider" *ngIf="showLoanSummaryView">
    <mat-card>
      <mat-card-content>
        <div>
          <mat-form-field>
            <mat-label>Cliente</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.parentName" disabled matInput />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Nombre producto</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.entityName" disabled matInput />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Tipo producto</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.entityType" disabled matInput />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Estado del préstamo</mat-label>
            <input type="text" [(ngModel)]="loanAccountSummary.entityStatus.value" disabled matInput />
          </mat-form-field>
          <mat-form-field *ngIf="showLoanRepaymentView">
            <mat-label>Moneda de la cuenta</mat-label>
            <input type="text" [(ngModel)]="loanRepaymentTemplate.currency.code" disabled matInput />
          </mat-form-field>
          <mat-form-field *ngIf="showLoanRepaymentView">
            <mat-label>Próximo pago</mat-label>
            <input type="text" [(ngModel)]="nextRepaymentDate" disabled matInput />
          </mat-form-field>
        </div>

      </mat-card-content>
    </mat-card>
  </div>

  <div id="search-divider" *ngIf="showLoanRepaymentView">
    <mat-card>

      <form [formGroup]="checkReversalLoanForm">

        <mat-card-content>

          <div fxLayout="column">

            <mat-form-field>
              <mat-label>Cheque a Rechazar</mat-label>
              <mat-select formControlName="checkId" required>
                <mat-option *ngFor="let curr of existentChecks" [value]="curr.id">
                  {{ curr.transactionDate }} - {{ curr.amount }} {{ curr.currencyCode }} -> (Banco {{ curr.bankCode }} | Cheque# {{ curr.checkNumber }} | Nr. Seg. {{ curr.checkNumber }}) 
                </mat-option>
              </mat-select>
              <mat-error *ngIf="checkReversalLoanForm.controls.checkId.hasError('required')">
                Cheque a Rechazar es <strong>obligatoria</strong>
              </mat-error>
            </mat-form-field>


            <mat-form-field>
              <mat-label>Codigo Rechazo</mat-label>
              <input matInput required formControlName="rejectCode">
              <mat-error *ngIf="checkReversalLoanForm.controls.rejectCode.hasError('required')">
                Codigo Rechazo es <strong>obligatorio</strong>
              </mat-error>
            </mat-form-field>


            <mat-form-field>
              <mat-label>Descripción</mat-label>
              <input matInput required formControlName="rejectDescription">
              <mat-error *ngIf="checkReversalLoanForm.controls.rejectDescription.hasError('required')">
                Descripción es <strong>obligatoria</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="35%" (click)="txDateFromDatePicker.open()">
              <mat-label>Fecha Cancelación</mat-label>
              <input matInput [matDatepicker]="txDateFromDatePicker" required
                  formControlName="transactionDate" 
                  (ngModelChange)="applyFilter()">
              <mat-datepicker-toggle matSuffix [for]="txDateFromDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #txDateFromDatePicker></mat-datepicker>
              <!--mat-error *ngIf="htmlForm.controls.transactionDate.hasError('required')">
                  Fechas es <strong>obligatoria</strong>
              </mat-error-->
            </mat-form-field>     

          </div>
        </mat-card-content>

      </form>

 
      <form [formGroup]="checkReversalLoanForm" (ngSubmit)="submit()">
        <mat-card-content fxLayout="column">
          <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
            <button type="button" mat-raised-button [routerLink]="['../../']">Cancelar</button>
            <button mat-raised-button color="primary" [disabled]="!checkReversalLoanForm.valid"
              [disabled]="isDisabled">Revertir</button>
          </mat-card-actions>
        </mat-card-content>
      </form>

    </mat-card>
  </div>

</div>